import { render, staticRenderFns } from "./Govern.vue?vue&type=template&id=a9df4620&scoped=true&"
import script from "./Govern.vue?vue&type=script&lang=js&"
export * from "./Govern.vue?vue&type=script&lang=js&"
import style0 from "./Govern.vue?vue&type=style&index=0&id=a9df4620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9df4620",
  null
  
)

export default component.exports